<template>
  <div
    class="pageSmallCard listItem"
    :class="{
      isUsed: itemData.orderStatus == 1 || itemData.orderStatus == 3,
    }"
  >
    <div>
      <div class="pageFlexBetween title">
        <p>
          {{ itemData.productName }}
        </p>
        <span class="pageFontWeight"
          >{{ $formatMoney(itemData.orderPrice, 1) }}元</span
        >
      </div>
      <div class="line"></div>
      <div class="detail">
        <div class="pageFlexColumn icons">
          <div class="pageBgBlock">
            <van-icon  name="alipay" size="40" v-if="itemData.categoryIdentification == 'alipayPoints'"/>
            <van-icon  name="wechat" size="40" v-if="itemData.categoryIdentification == 'weChatPoints'"/>
            <i class="iconfont icondingdan1" v-if="!['alipayPoints','weChatPoints'].includes(itemData.categoryIdentification)"></i>
          </div>
          <p :class="'pageDefaultRadius '">
            {{ ['待处理','已失败','已完成','已取消','待支付','处理中','待退款','未确认','待收款'][itemData.orderStatus] }}
          </p>
        </div>
        <div v-if="show" class="list">
          <li>订单编号：{{ itemData.orderNo }}</li>
          <li v-if="itemData.orderAccount">
            充值帐号：{{ itemData.orderAccount }}
          </li>
          <li>生成时间：{{ itemData.orderCreateTime }}</li>
          <li v-if="itemData.orderStatus === 2 || itemData.orderStatus === 1">
            完成时间：{{ itemData.orderModifyTime }}
          </li>
          <li v-if="itemData.orderStatus === 1">失败原因：订单失败</li>
          <li v-if="itemData.orderStatus === 2 && itemData.orderType === 1">
            <van-button
              size="small"
              type="default"
              @click="pwdHandle(itemData.orderId)"
              >查看卡密</van-button
            >
          </li>
          <li v-if="itemData.categoryIdentification == 'weChatPoints' && itemData.orderStatus === 8">
            <van-button
              size="small"
              type="default"
              @click="weChatRedPacketConfirm(itemData)"
              >确认收款</van-button
            >
          </li>
          <li v-if="itemData.categoryIdentification == 'alipayPoints' && ![1,3].includes(itemData.orderStatus)">
            <van-button
              size="small"
              type="info"
              @click="goPointsAccounts()"
              >查看</van-button
            >
          </li>
          <template  v-if="itemData.categoryIdentification == 'recovery'">
            <li v-if="itemData.orderStatus === 0">
              <p>预计完成：{{ itemData.couponsExpectedTime }} D+{{ itemData.couponsChargeTime }}</p>
            </li>
            <li v-if="itemData.orderStatus === 2">
              <van-button
                size="small"
                type="default"
                @click="() => goRecoveryServer()"
                >查看订单</van-button
              >
            </li>
          </template>
        </div>
      </div>
    </div>
    <div
      class="pageCardFooter btnGroud"
      v-if="(itemData.orderStatus === 4) & show"
    >
      <KBtn
        class="pageSmallBtns cancel"
        color="#F9F9F9"
        title="取消订单"
        @click="cancelClick(itemData.orderId)"
      />
      <KBtn
        class="pageSmallBtns btnBig"
        color="#70B603"
        title="支付订单"
        @click="payNow(itemData.orderId)"
      />
    </div>
    <div
      class="pageCardFooter btnGroud"
      v-if="itemData.orderStatus === 2 && itemData.videoId"
    >
      <KBtn
        class="pageSmallBtns btnBig"
        color="#70B603"
        title="观看视频"
        @click="watchVideo(itemData.videoId)"
      />
    </div>
    <van-dialog v-model="cardInfoShow">
      <div class="showPwd">
        <p v-if="cardInfo.cardNo">
          卡号：{{ cardInfo.cardNo
          }}<span
            @click="copyHandle(1)"
            style="color: cornflowerblue; margin-left: 10px"
            >复制</span
          >
        </p>
        <p>
          卡密：{{ cardInfo.cardPwd
          }}<span
            @click="copyHandle(2)"
            style="color: cornflowerblue; margin-left: 10px"
            >复制</span
          >
        </p>
        <p v-if="cardInfo.endTime">有效期止：{{ cardInfo.endTime }}</p>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { repay } from "api/submit";
import { Toast } from 'vant';
import { wechatPay, claimRedEnvelope } from "api/wechatSDK";
import { cancelOrder } from "api/submit";
import { getCardPwdInfo, redeemAgainWeChatRedPacketApi } from "api/onLine";
import { getWechatInfo } from "api/recycle"

export default {
  props: {
    itemData: {
      type: Object,
      default: () => ({}),
    },
    show: {
      type: Boolean,
      default: () => true,
    },
    alipayPointsBalance: {
      type: Number,
      default: () => 0,
    },
  },
  data() {
    return {
      html: "",
      orderStatus: "",
      cardInfoShow: false,
      cardInfo: [],
    };
  },
  created() {},
  mounted() {},
  methods: {
    async goRecoveryServer() {
      const res = await getWechatInfo()
      if (res.status === 200) {
        const url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${res.data.appid}&redirect_uri=${res.data.homeUrl}&response_type=code&scope=snsapi_base&state=${res.data.state}#wechat_redirect`
        console.log(url)
        location.href = url
      }
    },
    goPointsAccounts(){
      this.$push({ name: 'PointsAccounts' })
    },
    cancelClick(id) {
      this.$confirm("取消后不可恢复，确认要取消订单吗？", "确认提示", "#EE0A24")
        .then(() => {
          this.$loading("取消中");
          cancelOrder(id).then((res) => {
            this.$clear();
            if (res.status === 200) {
              this.$successSync("订单取消成功", () => {
                this.$parent.$parent.$parent.$parent.$parent.currentPages = 1;
                this.$parent.$parent.$parent.$parent.$parent.len = 0;
                this.$parent.$parent.$parent.$parent.$parent.finished = false;
                this.$parent.$parent.$parent.$parent.$parent.loading = true;
                this.$parent.$parent.$parent.$parent.$parent.onLoad();
              });
            } else {
              this.$error(res.message);
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    payNow(id) {
      this.$loading("支付中");
      repay(id).then((res) => {
        if (res.status === 200) {
          if ((typeof res.data == "object") & (res.data != null)) {
            if (res.data.appId != undefined) {
              wechatPay(res.data);
            }
          } else {
            this.$error(res.message);
          }
        } else {
          this.$error(res.message);
        }
      });
    },
    getIcon(type) {
      let arry = { icon: "", color: "" };
      switch (type) {
        //退款、余额充值、线下服务
        case 1:
        case 3:
          arry.icon = "icondingdan1";
          break;
        //油卡、加油广东
        case 4:
        case 13:
          arry.icon = "iconjiayouqia";
          break;
        //话费流量
        case 5:
        case 6:
          arry.icon = "iconu1053";
          break;
        //购物卡
        case 7:
          arry.icon = "iconqiapian";
          break;
        //视频、音乐、游戏充值
        case 8:
          arry.icon = "iconziyuan1";
          break;
        case 9:
          arry.icon = "iconu1081";
          break;
        case 10:
          arry.icon = "iconyouxi";
          break;
        //卡券购买
        case 2:
        case 11:
          arry.icon = "iconquan";
          break;
        //转让订单
        case 12:
          arry.icon = "iconzhuanrangzhuangtai";
          break;
        //健康档案、家医保、健康体检
        case 14:
          arry.icon = "iconjiankangdangan";
          break;
        case 15:
          arry.icon = "iconhuiyuan";
          break;
        //加油兑换券
        case 16:
          arry.icon = "iconjixuduihuan";
          break;
        case 17:
          arry.icon = "iconnianshendaoqitixing";
          break;
        case 18:
          arry.icon = "icondrive";
          break;
      }
      return arry;
    },
    pwdHandle(orderId) {
      getCardPwdInfo(orderId).then((res) => {
        if (res.status === 200) {
          this.cardInfo = res.data;
          this.cardInfoShow = true;
        } else {
          this.$error(res.message);
        }
      });
    },
    copyHandle(type) {
      let text;
      if (type === 1) {
        text = this.cardInfo.cardNo;
      } else if (type === 2) {
        text = this.cardInfo.cardPwd;
      } else {
        return;
      }
      this.$copyText(text).then(
        (e) => {
          this.$success("复制成功");
        },
        (e) => {
          this.$error("复制失败");
        }
      );
    },
    watchVideo(videoOrderId) {
      this.$push({
        path: `/showVideo?videoOrderId=${videoOrderId}`,
      });
    },
    async weChatRedPacketConfirm(itemData) {
      this.$loading("处理中");
      const { data, status, message } = await redeemAgainWeChatRedPacketApi(itemData.orderNo)
      this.$clear();
      if(!data || !data.mchId || !data.packageInfo) {
        alert("微信服务繁忙，请稍后再试！");
        return
      }
      if(status == 200){
        claimRedEnvelope(data.mchId, data.packageInfo, itemData.orderNo)
      }else{
        alert(message);
      }
    },
  },
};
</script>

<style scoped lang="less">
@themeColor: #fff;
.listItem {
  width: 100%;
  padding: 0;
  margin-top: 15px;
  min-height: 90px;
  font-size: var(--pFont);
  .goUrl {
    .van-divider {
      margin: 0px;
    }
    .van-cell__title,
    .van-cell__value {
      flex: initial;
    }
    .url {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-radius: 5px;
      .van-cell__title {
        width: 80%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
  .title {
    // height: 40px;
    padding: 10px 0;
    font-size: var(--titleFont);
    color: var(--titleColor);
    p {
      margin-left: 24%;
    }
    span {
      color: var(--redColor);
      margin-right: 13px;
      max-width: 95px;
      min-width: 50px;
      text-align: right;
    }
  }
  .line {
    height: 5px;
    margin: 0 2px;
    margin-top: -5px;
    box-shadow: 0px 4px 4px 2px #f4f4f4;
  }
  .unPay {
    p {
      color: var(--greenColor);
      background: #eef6e0;
    }
  }
  .processing {
    p {
      background: #fdecd5;
      color: var(--depYelColor);
    }
  }
  .detail {
    padding: 12px 0;
    display: flex;
    .icons {
      width: 19%;
      color: #666;
      margin: 0 10px;
      display: inline-flex;
      vertical-align: top;
      margin-top: -40px;
      .pageBgBlock {
        color: #fff;
        width: 50px;
        height: 50px;
        background: var(--redColor);
        margin-bottom: 4px;
        .iconfont {
          font-size: 28px;
          margin: 4px 10px;
        }
      }
      p {
        margin-top: 5px;
        padding: 5px 8px;
        font-size: var(--spanFont);
        color: var(--depBlueColor);
        background: #e0f4fd;
      }
      .pay {
        background: #eef6e0;
        color: #70b603;
      }
      .handle {
        background: #fdecd5;
        color: #ff3300;
      }
      .cancel {
        background: #fefefe;
        color: #000;
      }
    }
    .details {
      width: 73%;
      display: inline-block;
      line-height: 1.5;
      padding-bottom: 15px;
      li {
        font-size: var(--smallFont);
        color: #555555;
        word-break: break-all;
      }
    }
    .list {
      width: 66%;
      font-size: var(--smallFont);
      color: var(--hidColor) !important;
      display: inline-block;
      line-height: 1.8;
      li {
        word-break: break-all;
      }
    }
    .remark {
      margin-top: 5px;
      padding-top: 4px;
      font-size: var(--pFont);
      border-top: 1px solid var(--lineColor);
      color: var(--hidColor);
    }
    h5 {
      margin-top: 6px;
      color: var(--depBlueColor);
    }
  }
  .btnGroud {
    .pageSmallBtns {
      width: 50%;
      height: 40px;
      border-radius: 0px;
    }
    .btnBig {
      width: 100% !important;
    }
    .cancel {
      color: var(--depHidColor) !important;
    }
  }
  .showPwd {
    padding: 20px 10px 0;
    p {
      margin-bottom: 20px;
    }
  }
  .footer {
    color: #fff;
    background: var(--depBlueColor);
    height: 35px;
    padding: 0 15px;
    box-sizing: border-box;
    p {
      flex: 1;
    }
    .pageSmallBtns {
      color: var(--depBlueColor) !important;
      border-radius: 5px;
      font-size: var(--spanFont);
      height: 24px;
    }
  }
}
.isUsed {
  background: var(--bgColor);
  position: relative;
  border: 1px solid #fff;
  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(249, 249, 249, 0.5);
  }
}
</style>
